import React from 'react'

import { PriceSubscription } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import FreeTrialTag from 'Pods/UnifiedNavigation/Shared/FreeTrialTag/FreeTrialTag'
import MenuItem from 'Pods/UnifiedNavigation/Shared/MenuItem/MenuItem'
import Section from 'Pods/UnifiedNavigation/Shared/Section/Section'

// Subscription entry. The free-trial pill mirrors the Create with AI dropdown: it
// shows while a free trial is in progress or still attainable for the viewer. The
// parent threads `showFreeTrialTag` (same signal feeding the Create with AI tag) and
// `freeTrialLabel` (the same server-translated string as that tag), so both surfaces
// flip and read their label together.
function SubscriptionSection({ locale = 'en', showFreeTrialTag = false, freeTrialLabel = '' }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <Section divided>
      <MenuItem
        title={t('navigation.user_menu.seller.subscription')}
        url="/profile/subscription"
        svgComponent={PriceSubscription}
        iconClassName="unified-nav__dropdown-item-icon--rotated"
        dataName="Subscription"
      >
        {showFreeTrialTag && freeTrialLabel && <FreeTrialTag label={freeTrialLabel} />}
      </MenuItem>
    </Section>
  )
}

SubscriptionSection.propTypes = {
  locale: string,
  showFreeTrialTag: bool,
  freeTrialLabel: string,
}

export default SubscriptionSection
